import { Box } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useContext } from 'react';

import { TableContext } from '../store/store';

export const ActionsToolbar = () => {
  const { toolbar } = useContext(TableContext);
  return (
    <GridToolbarContainer>
      {toolbar?.showQuickFilter && <GridToolbarQuickFilter />}
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {toolbar?.showExportButton && (
        <GridToolbarExport
          printOptions={{
            disableToolbarButton: true,
          }}
        />
      )}
    </GridToolbarContainer>
  );
};
